module.exports = __webpack_public_path__ + "img/back-sidebar.bb88cda5.jpg";